<template>
  <span>{{ name }}</span>
</template>

<script>
import { getUserName } from "@/dashboard/services";
import { mapGetters } from "vuex";

export default {
  props: {
    staffId: String,
  },
  computed: {
    ...mapGetters("staffStore", ["usersMap"]),
    name() {
      const staff = this.usersMap[this.staffId];
      return getUserName(staff);
    },
  },
};
</script>
